import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ConsultantProfile = lazy(() => import('../pages/consultant/page'));
const BookingSuccess = lazy(() => import('../pages/booking-success/page'));
const BookingCancelled = lazy(() => import('../pages/booking-cancelled/page'));
const LoginPage = lazy(() => import('../pages/auth/login/page'));
const SignupBusinessPage = lazy(() => import('../pages/auth/signup-business/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const SignupBusiness = lazy(() => import('../pages/auth/signup-business/page'));
const SignupConsultant = lazy(() => import('../pages/auth/signup-consultant/page'));
const Login = lazy(() => import('../pages/auth/login/page'));
const BusinessDashboard = lazy(() => import('../pages/dashboard/business/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/consultant/:slug',
    element: <ConsultantProfile />,
  },
  {
    path: '/booking-success',
    element: <BookingSuccess />,
  },
  {
    path: '/booking-cancelled',
    element: <BookingCancelled />,
  },
  {
    path: '/signup-business',
    element: <SignupBusiness />,
  },
  {
    path: '/signup-consultant',
    element: <SignupConsultant />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/signup/business',
    element: <SignupBusinessPage />,
  },
  {
    path: '/dashboard',
    element: <BusinessDashboard />,
  },
  {
    path: '/dashboard/business',
    element: <BusinessDashboard />,
  },
  {
    path: '/dashboard/admin',
    element: lazy(() => import('../pages/dashboard/admin/page')),
  },
  {
    path: '/dashboard/consultant',
    element: lazy(() => import('../pages/dashboard/consultant/page')),
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
